/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DeletionSettings } from './DeletionSettings';
import {
    DeletionSettingsFromJSON,
    DeletionSettingsFromJSONTyped,
    DeletionSettingsToJSON,
} from './DeletionSettings';
import type { FieldSetting } from './FieldSetting';
import {
    FieldSettingFromJSON,
    FieldSettingFromJSONTyped,
    FieldSettingToJSON,
} from './FieldSetting';
import type { ValueDefault } from './ValueDefault';
import {
    ValueDefaultFromJSON,
    ValueDefaultFromJSONTyped,
    ValueDefaultToJSON,
} from './ValueDefault';

/**
 * 
 * @export
 * @interface WriteConfigObject
 */
export interface WriteConfigObject {
    /**
     * The name of the object to write to.
     * @type {string}
     * @memberof WriteConfigObject
     */
    objectName: string;
    /**
     * 
     * @type {DeletionSettings}
     * @memberof WriteConfigObject
     */
    deletionSettings?: DeletionSettings;
    /**
     * This is a map of field names to default values. These values will be used when writing to the object.
     * @type {{ [key: string]: ValueDefault; }}
     * @memberof WriteConfigObject
     * @deprecated
     */
    selectedValueDefaults?: { [key: string]: ValueDefault; };
    /**
     * This is a map of field names to their settings.
     * @type {{ [key: string]: FieldSetting; }}
     * @memberof WriteConfigObject
     */
    selectedFieldSettings?: { [key: string]: FieldSetting; };
}

/**
 * Check if a given object implements the WriteConfigObject interface.
 */
export function instanceOfWriteConfigObject(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "objectName" in value;

    return isInstance;
}

export function WriteConfigObjectFromJSON(json: any): WriteConfigObject {
    return WriteConfigObjectFromJSONTyped(json, false);
}

export function WriteConfigObjectFromJSONTyped(json: any, ignoreDiscriminator: boolean): WriteConfigObject {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'objectName': json['objectName'],
        'deletionSettings': !exists(json, 'deletionSettings') ? undefined : DeletionSettingsFromJSON(json['deletionSettings']),
        'selectedValueDefaults': !exists(json, 'selectedValueDefaults') ? undefined : (mapValues(json['selectedValueDefaults'], ValueDefaultFromJSON)),
        'selectedFieldSettings': !exists(json, 'selectedFieldSettings') ? undefined : (mapValues(json['selectedFieldSettings'], FieldSettingFromJSON)),
    };
}

export function WriteConfigObjectToJSON(value?: WriteConfigObject | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'objectName': value.objectName,
        'deletionSettings': DeletionSettingsToJSON(value.deletionSettings),
        'selectedValueDefaults': value.selectedValueDefaults === undefined ? undefined : (mapValues(value.selectedValueDefaults, ValueDefaultToJSON)),
        'selectedFieldSettings': value.selectedFieldSettings === undefined ? undefined : (mapValues(value.selectedFieldSettings, FieldSettingToJSON)),
    };
}

